"use client";
import React from "react";
import Avatar from "../primitives/avatar";
import Link from "next/link";
import * as Collapsible from "@radix-ui/react-collapsible";
import Icon from "../primitives/icon";
import CommentForm from "./comment-form";
import { DiscussionComment } from "common";
import { createProfileSlug } from "@/utils/url";
import RelativeTime from "../relative-time";
import { formatUnits } from "@/utils";

export default function GameComment({
  gameId,
  data,
  disabled,
}: {
  gameId: number;
  data: DiscussionComment;
  disabled?: boolean;
}) {
  console.log("data from comment", data);
  // const [children, setChildren] = React.useState<DiscussionComment[] | undefined>(data.children);
  const [open, setOpen] = React.useState<boolean>(false);
  const [replying, setReplying] = React.useState<boolean>(false);
  const [justReplied, setJustReplied] = React.useState<boolean>(false);
  const replyCount: number =
    data.children?.length && data.children.length ? data.children.length : 0;
  const hasReplies: boolean = replyCount > 0;

  function handleReply() {
    setReplying((prev) => !prev);
  }

  React.useEffect(() => {
    if (justReplied && hasReplies) {
      setOpen(true); 
      setJustReplied(false);
    }
  }, [justReplied, hasReplies]);

  return (
    <div className="flex flex-col w-full desktop-grid:flex-row justify-between items-start desktop-grid:items-center mb-2">
      <div className="flex-col w-full">
        <div className="flex flex-row gap-2 w-full">
          <Link href={createProfileSlug(data.bettor.username)}>
            <Avatar img={data.bettor.avatar}></Avatar>
          </Link>
          <div className="flex flex-col gap-1">
            <div className="flex flex-row items-center gap-2 flex-wrap">
              <Link
                href={createProfileSlug(data.bettor.username)}
                className="text-title-sm-medium text-dark"
              >
                {data.bettor.username}
              </Link>
              <div className="flex flex-row gap-2 items-center">
                {/* <div className="text-title-sm text-secondary">
                  <span>
                    {data.bettor.units}{" "}
                    {`${data.bettor.units === 1 ? "Unit" : "Units"}`}
                  </span>
                </div> */}
                {data.createdAt && (
                  <div className="text-title-sm text-secondary">
                    <RelativeTime date={data.createdAt} />
                  </div>
                )}
                {data.bettor.picks && data.bettor.picks !== 0 ? (
                  <div className="h-5 px-2 bg-surface-400 flex items-center rounded-sm">
                    <span className="text-label-lg-medium active-picks-text">
                      {data.bettor.picks} Pick{data.bettor.picks === 1 ? "" : "s"}
                    </span>
                  </div>
                ) : undefined}
              </div>
            </div>
            <div className="text-sm text-dark">{data.comment}</div>
            <div className="flex flex-row gap-2 items-center">
              {!disabled && (
                <button
                  onClick={handleReply}
                  className="focus-visible:ring text-label-lg-bold text-secondary-600 uppercase rounded-full py-1 px-0 md:px-2 hover:bg-surface-400"
                >
                  {replying ? "Cancel" : "Reply"}
                </button>
              )}
            </div>
          </div>
        </div>
        {replying && !disabled && (
          <div className="pl-10 md:pl-10 pb-1">
            <CommentForm
              gameId={gameId}
              replyingTo={data.id}
              disabled={disabled || false}
              setReplying={setReplying}
              setJustReplied={setJustReplied}
            />
          </div>
        )}
        {hasReplies && (
          <Collapsible.Root
            onOpenChange={setOpen}
            className="group pl-10 md:pl-10 overflow-hidden"
          >
            <Collapsible.Trigger asChild>
              <button className="focus-visible:ring z-[1] relative flex flex-row gap-[10px] text-title-sm-medium text-secondary-300 rounded-full hover:bg-primary-600 items-center px-0 md:px-3 py-2">
                {open ? (
                  <Icon name="caret-up" size="sm" />
                ) : (
                  <Icon name="caret-down" size="sm" />
                )}
                {replyCount} {`${replyCount === 1 ? "Reply" : "Replies"}`}
              </button>
            </Collapsible.Trigger>
            <Collapsible.Content className="data-[state=open]:animate-unCollapse data-[state=closed]:animate-collapse bg-white relative z-0 rounded-bl-lg rounded-br-lg">
              <div className="pt-2">
                {data.children?.map((childComment) => (
                  <GameCommentChild data={childComment} />
                ))}
              </div>
            </Collapsible.Content>
          </Collapsible.Root>
        )}
      </div>
    </div>
  );
}

function GameCommentChild({ data }: { data: DiscussionComment }) {
  return (
    <div className="flex flex-row gap-2 mb-2">
      <Link href={createProfileSlug(data.bettor.username)}>
        <Avatar img={data.bettor.avatar}></Avatar>
      </Link>
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center gap-2 flex-wrap">
          <Link
            href={createProfileSlug(data.bettor.username)}
            className="text-title-sm-medium text-dark"
          >
            {data.bettor.username}
          </Link>
          <div className="flex flex-row gap-2 items-center">
            {/* <div className="text-title-sm text-secondary">
              <span>
                {data.bettor.units}{" "}
                {`${data.bettor.units === 1 ? "Unit" : "Units"}`}
              </span>
            </div> */}
            {data.createdAt && (
              <div className="text-title-sm text-secondary">
                <RelativeTime date={data.createdAt} />
              </div>
            )}
            {/* <div className="text-title-sm text-secondary">
                {formatUnits(data.bettor.units)} Units (Last 30 days)
              </div> */}
          </div>
        </div>
        <div className="text-sm text-dark">{data.comment}</div>
        <div className="flex flex-row gap-2 items-center"></div>
      </div>
    </div>
  );
}
